export enum SapItemType {
    CnaeBilling = 1,
    CnaeConsultant = 2,
    ItemPurchaseOrder = 3
}



// WEBPACK FOOTER //
// ./src/app/shared/enums/SapItemType.ts